<template>
  <b-card no-body>
    <b-tabs card lazy>
      <b-tab title="Criteria Group" active>
        <b-col md="12">
          <Heading1 text="List group criteria">
            <b-button size="lg" variant="light" @click="fetchListGroupCriteria">
              <b-icon-arrow-repeat />
            </b-button>
            <CreateGroupCriteriaForm @onSubmit="createGroupCriteria" :options="listCriteria" />
          </Heading1>

          <b-row>
            <b-col>
              <b-table striped hover :fields="groupCriteriaFields" :items="listGroupCriteria" responsive="sm">
                <template v-slot:cell(explanation)="data">
                  <pre>
                {{ data.item.explanation }}
              </pre
                  >
                </template>

                <template v-slot:cell(updater)="data">
                  <span class="small">{{ data.item.updater.name }}</span>
                </template>

                <template v-slot:cell(updatedAt)="data">
                  <span class="text-nowrap">{{ fmtDate(data.item.updatedAt) }}</span>
                </template>
              </b-table>
            </b-col>
          </b-row>
        </b-col>
      </b-tab>
      <b-tab title="Criteria">
        <b-col>
          <Heading1 text="List criteria">
            <b-button size="lg" variant="light" @click="fetchListCriteria">
              <b-icon-arrow-repeat />
            </b-button>
            <CreateCriteriaForm @onSubmit="createCriteria" />
          </Heading1>
          <b-row>
            <b-col>
              <b-table striped hover :fields="criteriaFields" :items="listCriteria" responsive="sm">
                <template v-slot:cell(updater)="data">
                  <span class="text-nowrap">{{ data.item.updater.name }}</span>
                </template>

                <template v-slot:cell(updatedAt)="data">
                  <span class="text-nowrap">{{ fmtDate(data.item.updatedAt) }}</span>
                </template>
              </b-table>
            </b-col>
          </b-row>
        </b-col>
      </b-tab>
    </b-tabs>
  </b-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import CreateCriteriaForm from '../components/CreateCriteriaForm';
import CreateGroupCriteriaForm from '../components/CreateGroupCriteriaForm';
import Heading1 from '@/components/Heading1';

import api from '../api';

export default {
  name: 'ManagingCriteria',
  components: { CreateGroupCriteriaForm, CreateCriteriaForm, Heading1 },
  data() {
    return {
      criteriaFields: [
        { key: 'title', label: 'Title' },
        'explanation',
        {
          key: 'updater',
          label: 'Author',
        },
        {
          key: 'updatedAt',
          label: 'Last update',
        },
      ],
      groupCriteriaFields: [
        'name',
        {
          key: 'updater',
          label: 'Author',
        },
        {
          key: 'updatedAt',
          label: 'Last update',
        },
      ],
    };
  },
  computed: {
    ...mapGetters('criteria', ['listCriteria', 'listGroupCriteria']),
  },
  methods: {
    ...mapActions('criteria', ['fetchListCriteria', 'fetchListGroupCriteria']),
    createCriteria(formData) {
      api
        .gql({
          query: `mutation createCriteria($input: createCriteriaInput!) {
          createCriteria(input: $input) {
            out {
              id
            }
          }
        }`,
          variables: {
            input: {
              title: formData.title,
              explanation: formData.explanation,
              type: formData.type,
            },
          },
        })
        .then(({ createCriteria: { out } }) => {
          this.$toastr.s(JSON.stringify(out, null, 2), 'Created Criteria');
        });
    },
    createGroupCriteria(formData) {
      api
        .gql({
          query: `mutation createGroupCriteria($input: createGroupCriteriaInput!) {
            createGroupCriteria(input: $input) {
              out {
                id
              }
            }
          }`,
          variables: {
            input: {
              name: formData.name,
              criteriaIds: formData.criteriaIds,
            },
          },
        })
        .then(({ createGroupCriteria: { out } }) => {
          this.$toastr.s(JSON.stringify(out, null, 2), 'Created Group Criteria');
        });
    },
  },
  mounted() {
    this.fetchListCriteria();
    this.fetchListGroupCriteria();
  },
};
</script>
